#!/usr/bin/env node

import { program } from 'commander';
import { DevCommand } from '../src/commands/DevCommand.js';
import { BuildCommand } from '../src/commands/BuildCommand.js';
import { PreviewCommand } from '../src/commands/PreviewCommand.js';
import { InitCommand } from '../src/commands/InitCommand.js';
import { TestCommand } from '../src/commands/TestCommand.js';
import { UpdateCommand } from '../src/commands/UpdateCommand.js';
import { ScaffoldCommand } from '../src/commands/ScaffoldCommand.js';

const cwd = process.cwd();

program
	.command('dev')
	.description('Start the development server')
	.option('-p, --port <port>', 'Port to run the dev server on')
	.option('-h, --host <host>', 'Host to bind the dev server to')
	.option('--open', 'Open browser automatically')
	.action(async (options) => {
		const command = new DevCommand(cwd);
		await command.execute(options);
	});

program
	.command('build')
	.description('Build the application for production')
	.option('-t, --target <target>', 'Build target (static, bodify, server). Defaults to frame.config build.target, else "static".')
	.option('-o, --outDir <dir>', 'Output directory', 'dist')
	.option('--watch', 'Watch for changes and rebuild')
	.action(async (options) => {
		const command = new BuildCommand(cwd);
		await command.execute(options);
	});

program
	.command('preview')
	.description('Preview the production build')
	.option('-p, --port <port>', 'Port to run the preview server on', '4173')
	.option('-h, --host <host>', 'Host to bind the preview server to', 'localhost')
	.option('--open', 'Open browser automatically')
	.action(async (options) => {
		const command = new PreviewCommand(cwd);
		await command.execute(options);
	});

program
	.command('test [filter]')
	.description('Run tests')
	.option('-w, --watch', 'Watch mode')
	.option('-c, --coverage', 'Generate coverage report')
	.option('--ui', 'Open test UI')
	.option('--run', 'Run tests once and exit')
	.option('-r, --reporter <reporter>', 'Test reporter')
	.action(async (filter, options) => {
		const command = new TestCommand(cwd);
		await command.execute({ ...options, filter });
	});

program
	.command('init [name]')
	.alias('create')
	.description('Initialize a new Frame project')
	.option('-t, --template <template>', 'Project template to use', 'default')
	.option('--typescript', 'Use TypeScript')
	.option('--eslint', 'Include ESLint configuration')
	.option('--prettier', 'Include Prettier configuration')
	.option('--pinia', 'Include Pinia store')
	.option('--testing', 'Include testing setup (Vitest)')
	.option('--git', 'Initialize git repository')
	.action(async (name, options) => {
		const command = new InitCommand(cwd);
		await command.execute({ name, ...options });
	});

program
	.command('scaffold <type> [name]')
	.alias('generate')
	.description('Scaffold new components, views, or other files')
	.option('-t, --template <template>', 'Template to use for scaffolding')
	.option('--typescript', 'Generate TypeScript files')
	.option('--test', 'Generate test files')
	.action(async (type, name, options) => {
		const command = new ScaffoldCommand(cwd);
		await command.execute({ type, name, ...options });
	});

program
	.command('update')
	.description('Update Frame configuration and dependencies')
	.option('--pug', 'Add Pug templating support')
	.option('--meta', 'Add meta management support')
	.option('--pinia', 'Add Pinia store')
	.option('--testing', 'Add testing setup')
	.option('--eslint', 'Add ESLint configuration')
	.option('--prettier', 'Add Prettier configuration')
	.option('--all', 'Add all available features')
	.action(async (options) => {
		const command = new UpdateCommand(cwd);
		await command.execute(options);
	});

program
	.command('deploy')
	.description('Deploy the application')
	.option('-t, --target <target>', 'Deployment target')
	.option('--dry-run', 'Show what would be deployed without actually deploying')
	.action(async (options) => {
		console.log('[Frame] Deploy command coming soon!');
		console.log('Target:', options.target || 'auto-detect');
	});

program
	.command('lint')
	.description('Lint and format code')
	.option('--fix', 'Automatically fix problems')
	.option('--format', 'Format code with Prettier')
	.action(async (options) => {
		console.log('[Frame] Lint command coming soon!');
		console.log('Options:', options);
	});

program
	.name('frame')
	.description('Frame - Vue.js infrastructure made simple')
	.version('0.3.0');

program.parse(); 